import type { SvgIconProps } from "@mui/material";
import { ListItemIcon as MuiListItemIcon } from "@mui/material";

export type ListItemIconProps = SvgIconProps & {
  iconPath: string;
  alt?: string;
};

export const ListItemIcon = ({
  iconPath,
  alt,
  width,
  height,
}: ListItemIconProps) => {
  if (!iconPath) {
    console.error("iconPath is required but was not provided.");
    return null;
  }

  return (
    <MuiListItemIcon>
      <img
        src={iconPath}
        alt={alt}
        width={width}
        height={height}
        aria-label={alt}
      />
    </MuiListItemIcon>
  );
};
